<sirius-icon class="route-notice-icon" name="info" aria-hidden="true" />
<p class="route-notice-message sir-text-style-paragraph-s-default">{{ message() }}</p>
@if (undoLabel()) {
    <button siriusButton class="route-notice-undo" buttonType="linkstyle" size="small" type="button" (click)="undo.emit()">
        {{ undoLabel() }}
    </button>
}
